<template>
    <div
        ref="nearbyLocations"
        class="search-geolink flow-column"
        v-if="currentList && currentList.length"
        comp="searchGeolink"
    >
         <div>
             <h2 class="f4 text-bold">Explore nearby locations</h2>
             <span class="text-gray">The prices shown are the median list prices.</span>
         </div>
        <ul>
            <li>
                <button :class="{ active: type === 'city' }" type="button" v-if="cities.length" @click="toggle('city')">
                    {{ molang('search.common.cities') }}
                </button>
            </li>
            <li>
                <button :class="{ active: type === 'zipcode' }" type="button" v-if="zipcodes.length" @click="toggle('zipcode')">
                    {{ molang('search.common.zipCodes') }}
                </button>
            </li>
            <li>
                <button :class="{ active: type === 'neighborhood' }" type="button" v-if="neighborhoods.length" @click="toggle('neighborhood')">
                    {{ molang('search.common.neighborhoods') }}
                </button>
            </li>
            <li>
                <button :class="{ active: type === 'county' }" type="button" v-if="counties.length" @click="toggle('county')">
                    {{ molang('search.common.counties') }}
                </button>
            </li>
        </ul>
        <div class="search-linklist show" v-if="visibleList.length">
            <div v-for="item in visibleList" :key="item.name">
                <a :href="`${glb.appUrl}${item.url}`">{{ item.name }}{{ linkSuffix ? ` ${linkSuffix}` : '' }}</a>
                <p v-if="item.price">{{ $filters.formatPrice(item.price) }}</p>
            </div>
        </div>
        <button v-if="showToggle" type="button" @click="toggleShowMore">
            {{ showMore ? 'Show Less' : 'Show More' }} <i :class="showMore ? 'icon-angle-up' : 'icon-angle-down'"></i>
        </button>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'searchGeoLink',
    data() {
        return {
            selectedType: '',
            showMore: false,
        };
    },
    methods: {
        toggle(type) {
            this.selectedType = type;
            this.showMore = false;
        },
        toggleShowMore() {
            this.showMore = !this.showMore;
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', [
            'getGeoDisplayText',
            'getNearbyCities',
            'getNearbyZipcodes',
            'getNearbyNeighborhood',
            'getNearbyCounties',
        ]),
        linkSuffix() {
            const key = this.glb.rentals ? 'search.common.homesForRentIn' : 'search.common.homesForSaleIn';
            return (this.molang(key) || '').replace(/\s+in\s*$/i, '') || (this.glb.rentals ? 'homes for rent' : 'homes for sale');
        },
        type() {
            if (this.selectedType) {
                return this.selectedType;
            }
            if (this.getNearbyCities && this.getNearbyCities.length) {
                return 'city';
            }
            if (this.getNearbyZipcodes && this.getNearbyZipcodes.length) {
                return 'zipcode';
            }
            if (this.getNearbyNeighborhood && this.getNearbyNeighborhood.length) {
                return 'neighborhood';
            }
            if (this.getNearbyCounties && this.getNearbyCounties.length) {
                return 'county';
            }
            return null;
        },
        cities() {
            if (!this.getNearbyCities || !this.getNearbyCities.length) return [];
            return this.getNearbyCities
                .filter((city) => city.sitemapCityPropertyPageUrl)
                .slice(0, 16)
                .map((city) => ({
                    name: city.displayName,
                    price: city.medianListPrice,
                    url: city.sitemapCityPropertyPageUrl,
                }))
        },
        zipcodes() {
            if (!this.getNearbyZipcodes || !this.getNearbyZipcodes.length) return [];
            return this.getNearbyZipcodes
                .filter((zipcode) => zipcode.sitemapZipCodePageUrl)
                .slice(0, 10)
                .map((zipcode) => ({
                    name: `${zipcode.displayName}, ${zipcode.stateCode}`,
                    price: zipcode.medianListPrice,
                    url: zipcode.sitemapZipCodePageUrl,
                }));
        },
        neighborhoods() {
            if (!this.getNearbyNeighborhood || !this.getNearbyNeighborhood.length) return [];
            return this.getNearbyNeighborhood
                .filter((n) => n.sitemapNeighborhoodPageUrl || n.neighborhoodPath)
                .slice(0, 10)
                .map((neighborhood) => ({
                    name: neighborhood.displayName || neighborhood.neighborhood,
                    price: neighborhood.medianListPrice,
                    url: neighborhood.sitemapNeighborhoodPageUrl || neighborhood.neighborhoodPath,
                }));
        },
        counties() {
            if (!this.getNearbyCounties || !this.getNearbyCounties.length) return [];
            return this.getNearbyCounties
                .filter((county) => county.sitemapCountyPageUrl)
                .slice(0, 10)
                .map((county) => ({
                    name: county.displayName,
                    price: county.medianListPrice,
                    url: county.sitemapCountyPageUrl,
                }));
        },
        currentList() {
            if (this.type === 'city') return this.cities;
            if (this.type === 'zipcode') return this.zipcodes;
            if (this.type === 'neighborhood') return this.neighborhoods;
            if (this.type === 'county') return this.counties;
            return null;
        },
        initialVisibleCount() {
            return this.glb.isMobile ? 5 : 10;
        },
        visibleList() {
            if (!this.currentList) return [];
            return this.showMore ? this.currentList : this.currentList.slice(0, this.initialVisibleCount);
        },
        showToggle() {
            return !!this.currentList && this.currentList.length > this.initialVisibleCount;
        },
    },
};
</script>
<style lang="scss">
@use './search-geolink.scss' as *;
</style>
